import React from 'react';
import {
    Stack,
    Box,
    Card,
    CardContent,
    CardHeader,
    ButtonBase,
    Typography,
    Divider,
} from '@mui/material';
import {
    Person as UserIcon,
    LocationOn as MapPinIcon,
    CheckCircle,
    Add as AddIcon,
} from '@mui/icons-material';
import {MyButton, MyTypography} from '../../common/components';


export function CreateReferralCard({onClickCreateReferral}) {
    return (
        <ButtonBase
            component={Card}
            elevation={1}
            onClick={onClickCreateReferral}
            sx={{
                width: '100%',
                maxWidth: 240,
                height: '100%',
                minHeight: 180,
                bgcolor: 'background.default',
            }}>
            <Stack direction="column"
                   alignItems="center"
                   justifyContent="center"
                   spacing={1}>
                <AddIcon sx={{ fontSize: 38, color: 'grey.A700' }} />
                <MyTypography variant="h5" color="inherit" sx={{fontWeight: 400, color: 'grey.A700'}}>Click here to create referral</MyTypography>
            </Stack>
        </ButtonBase>
    )
}

export default function DetectedReferralCard({ referral, onClickCreateReferral }) {
    const birthdate = referral.birthdate?.value ?? '',
          ssn = referral.ssn?.value ?? '',
          referringClinic = referral.referring_clinic?.value ?? '',
          diagnosis = referral?.diagnosis?.value ?? '';

    return (
        <Card elevation={1}>
            <CardHeader
                avatar={<UserIcon color="primary" />}
                title={
                    <MyTypography variant="h6" component="div">{referral.patient_name}</MyTypography>
                }
                subheader={
                    <Stack direction="row"
                           spacing={1}
                           alignItems="flex-start">
                        <MyTypography variant="subtitle2" sx={{minWidth: 60}}>{`DOB: ${birthdate}`}</MyTypography>
                        <MyTypography variant="subtitle2" sx={{minWidth: 60}}>{`SSN: ${ssn}`}</MyTypography>
                    </Stack>
                }
                sx={{ pb: 1, background: '#fff' }}
            />

            <CardContent sx={{ pt: 0 }}>
                <Box sx={{ mb: 2 }}>
                    {/*<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>*/}
                    {/*    <MapPinIcon fontSize="small" />*/}
                    {/*    <Typography variant="body2">*/}
                    {/*        <strong>Provider:</strong> {referral.referring_provider?.value}*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <UserIcon fontSize="small" />
                        <Typography variant="body2">
                            <strong>Clinic:</strong> {referringClinic}
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" fontWeight="600" gutterBottom>
                        Diagnosis:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {diagnosis}
                    </Typography>
                </Box>

                <MyButton
                    variant="contained"
                    startIcon={<CheckCircle />}
                    onClick={onClickCreateReferral}>
                    Create Referral
                </MyButton>
            </CardContent>
        </Card>
    );
}
